export default {
  /* */
  UPDATE: 'primaccess/UPDATE',
  ADD_PRODUCT_TO_CART: 'primaccess/ADD_PRODUCT_TO_CART',
  /* */
  gql: {
    GET_CLIENT: `
      query GetClient(
        $golfId: String!
        $accountId: String!
      ) {
        PA_getClient(
          golfId: $golfId
          accountId: $accountId
        ) {
          id
          isSU
          balance
          expiredAt
          createdAt
          badges {
            id
            startDate
          }
          nfcPasses {
            id
            token
            startDate
            isAssigned
            isEnabled
          }
        }
      }
    `,
    GET_PRODUCTS: `
      query GetProducts(
          $golfId: String!
          $accountId: String
        ) {
          PA_getProducts(
            golfId: $golfId
            accountId: $accountId
          ) {
            id
            name
            value
            price
          }
        }
    `,
    SEARCH_MOVES: `
      query SearchMoves(
        $limit: Int
        $offset: Int
        $clientId: Int!
        $golfId: String!
        $endpointId: [Int]
      ) {
        PA_searchMoves(
          limit: $limit
          offset: $offset
          golfId: $golfId
          clientId: $clientId
          endpointId: $endpointId
        ) {
          moves {
            error
            badgeId
            createdAt
            endpointId
          }
          metadata {
            limit
            total
            offset
          }
        }
      }
    `,
    GET_ENDPOINTS: `
      query GetEndpoints(
        $golfId: String!
      ) {
        PA_getEndpoints(
          golfId: $golfId
        ) {
          id
          tag
          name
        }
      }
    `,
    SEARCH_OPERATIONS: `
      query SearchOperations(
        $type: Int
        $limit: Int
        $offset: Int
        $clientId: Int!
        $golfId: String!
      ) {
        PA_searchOperations(
          type: $type
          limit: $limit
          offset: $offset
          golfId: $golfId
          clientId: $clientId
        ) {
          operations {
            name
            type
            amount
            foreign
            golfName
            createdAt
          }
          balance
          metadata {
            limit
            total
            offset
          }
        }
      }
    `,
    GET_REFILL_STATUS: `
      query GetRefillStatus(
        $accountId: String!
        $golfId: String!
      ) {
        PA_getRefillStatus(
          accountId: $accountId
          golfId: $golfId
        ) {
          id
          status
          createdAt
          product
          golf {
            id
            name
            slug
            email
          }
          account {
            id
            firstname
            lastname
            email
          }
        }
      }
    `,
    GET_REFILL_STATUS_BY_TOKEN: `
      query GetRefillStatusByToken(
        $token: String!
      ) {
        PA_getRefillStatusByToken(
          token: $token
        ) {
          id
          status
          createdAt
          product
          golf {
            id
            name
            slug
            email
          }
          account {
            id
            firstname
            lastname
            email
          }
        }
      }
    `,
    CREATE_OPERATION: `
      mutation CreateOperation(
        $clientId: Int!
        $golfId: String!
        $product: PA_ProductInput!
        $transaction: PA_TransactionInput!
      ) {
        PA_createOperation(
          golfId: $golfId
          product: $product
          clientId: $clientId
          transaction: $transaction
        ) {
          success
        }
      }
    `,
    SET_REFILL_STATUS: `
      mutation SetRefillStatus(
        $accountId: String!
        $golfId: String!
        $status: Boolean!
        $product: String
      ) {
        PA_setRefillStatus(
          accountId: $accountId
          golfId: $golfId
          status: $status
          product: $product
        ) {
          id
          status
          createdAt
          product
          golf {
            id
            name
            slug
            email
          }
          account {
            id
            firstname
            lastname
            email
          }
        }
      }
    `,
    ASSIGN_NFC_PASS: `
      mutation AssignNfcPass(
        $accountId: String!
        $clientId: Int!
        $golfId: String!
      ) {
        PA_assignNfcPass(
          accountId: $accountId
          clientId: $clientId
          golfId: $golfId
        ) {
          id
          token
          startDate
          isAssigned
          isEnabled
        }
      }
    `,
    SEND_NFC_PASS: `
      mutation SendNfcPass(
        $accountId: String!
        $badgeId: Int!
        $clientId: Int!
        $golfId: String!
      ) {
        PA_sendNfcPass(
          accountId: $accountId
          badgeId: $badgeId
          clientId: $clientId
          golfId: $golfId
        )
      }
    `,
    CREATE_CLIENT: `
      mutation CreateClient(
        $accountId: String!
        $golfId: String!
      ) {
        PA_createClient(
          accountId: $accountId
          golfId: $golfId
        )
      }
    `,
  },
};
